import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

export interface ItemResponseWrapper<T> {
  data: T;
}

export interface IListResponseMetadata {
  hasNext: boolean;
  hasPrevious: boolean;
  itemsPerPage: number;
  page: number;
  totalResults: number;
}

export const DEFAULT_METADATA: IListResponseMetadata = {
  hasNext: false,
  hasPrevious: false,
  itemsPerPage: 20,
  page: 1,
  totalResults: 0,
}

export interface ListResponseWrapper<T> extends ItemResponseWrapper<T[]> {
  meta: IListResponseMetadata;
}

export interface ErrorFieldEntity {
  code: string,
  field: string,
  message: string,
  data: null
}

export interface ErrorResponseWrapper {
  statusCode: HttpStatusCode,
  code: string,
  message: string,
  errors: ErrorFieldEntity[],
  timestamp: Date
}

export class ApiErrorResponse extends HttpErrorResponse {
  public error: {
    error: ErrorResponseWrapper
  };
}

export interface IPatchBody {
  op: 'add'|'remove'|'replace'|'move'|'copy'|'test',
  path: string;
  value: unknown;
}
